$(function () {

    if (!$('#comment-quote-page').length) return;

    const translation_id = getURLParameter("translation_id");
    const key = getURLParameter("key");

    const pageContainer = $("#comment-quote-page")[0];

    if (!translation_id || !key) { // missing URL parameter
        getTranslationFailed();
        return;
    }

	let translation;

    // display loader
    $(pageContainer).prepend('<div class="loader-overlay"><div class="spinner-grow page-loader"></div></div>');

	// make request to API
    $.ajax({
        type: "GET",
        url: `${getApiURL('translations')}/${translation_id}/key/${key}?responseGroups=FILES`,
        dataType: "json",
        success: function (object) {
			translation = object;
			if (translation.status !== 'quotation') {
				getTranslationFailed('There is no quote to comment for this translation!');
				return;
			}
			
            populateObjectData(pageContainer, translation, '', {"request_quote": "boolean", "day_required": "day_required"});

			// Comment Quote
			if (translation.day_required == "normal") {
				$("#quote-comments").after('<label for="quote-comments">If you wish to get an early completion for your job please indicate it in this field.</label>');
			}

            // display nicely the status
            $('[data-name=status]').html(label_status(translation));

            // files list
            translation.translation_files.forEach(file => {
                $("#translation-files-list").append(
                    `<li>${file.file} FROM ${file.language_from} TO ${file.language_to}</li>`
                );
            });
            $(pageContainer).find(".loader-overlay").remove();
        },
        error: function (request, textStatus, errorThrown) {
            getTranslationFailed(parseCallbackError(request, errorThrown));
        }
    });

    function getTranslationFailed(message) {
        $(pageContainer).hide();
        ATLAlerts.addError(message);
        $('#atl-alerts-div').append(ATLAlerts.displayAlerts(true));
        $(pageContainer).find(".loader-overlay").remove();
    }

    $("#comment-quote-form").on("submit", function(e) {
        e.preventDefault();

        const form = $('#comment-quote-form');
        const formData = getFormData(form);

        if (formData["comments"].length == 0) {
            alert('Please fill out the comment section.');
            return false;
        }

        $.ajax({
            type: "POST",
            url: `${getApiURL("translations")}/${translation_id}/key/${key}/comment`,
            headers: { "Token": $.cookie('token_api') },
            data: formData,
            dataType: "json",
            success: function () {
                ATLAlerts.addSuccess(`Thank you for your response! You will receive a confirmation email shortly.`);
                $(pageContainer).hide();
                $('#atl-alerts-div').append(ATLAlerts.displayAlerts(true));
            },
            error: function (request, textStatus, errorThrown) {
                getTranslationFailed(parseCallbackError(request, errorThrown));
            }
        });
    })
});